(function () {
    'use strict';

    function commentsMenu(workflowStateService, sessionDataService, notifyService, $rootScope) {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/commentsMenu.html',
            scope: {
                path: '=',
                comments: '='
            },
            link: function (scope, element, attrs) {
                sessionDataService.loadSession().then(function (session) {
                    scope.sessionData = session;

                    scope.comments.forEach(function (comment) {
                       if (!comment.IsDeleted && !comment.IsResolved && (scope.sessionData.EntityId === comment.CreatedByEntityId) &&
                            !scope.comments.some(function (outerComments) { return outerComments.CanResolve && !outerComments.IsDeleted; })) {
                            comment.CanResolve = true;
                        }
                    });
                })


                scope.comments.forEach(function (comment) {
                    comment.mode = 'display';
                });

                scope.deleteComment = function (comment) {
                    workflowStateService.removeUnderwritingNote(comment.NoteId);
                    var matchingComment = scope.comments.find(function (matchingComment) {
                        return matchingComment.NoteId === comment.NoteId;
                    });
                    if (matchingComment) {
                        matchingComment.IsDeleted = true;
                    }
                    comment.IsDeleted = true;
                    $rootScope.$broadcast("noteRemoved", comment.Path);
                }

                scope.editComment = function (comment) {
                    comment.mode = 'edit';
                    comment.originalNoteText = comment.Note;
                    scope.saveCommentObject.saveCommentText = comment.Note;
                    scope.saveCommentObject.originalComment = comment;
                }

                function getTargetUsers(text, originalPartners) {
                    var targetUsers = {};
                    var regex = /\b\+?\w+[\.-]?\w+@\w+[\.-]?\w+\.\w{2,3}/mg;
                    var str = text;
                    var m;
                    while ((m = regex.exec(str)) !== null) {
                        // This is necessary to avoid infinite loops with zero-width matches
                        if (m.index === regex.lastIndex) {
                            regex.lastIndex++;
                        }
                        // The result can be accessed through the `m`-variable.
                        m.forEach(function (match) {
                            if (match) {
                                targetUsers[match] = originalPartners.find(function (p) { return p.UserName === match; }).Id;
                            }
                        });
                    }

                    return targetUsers;
                }

                // Add Comment
                scope.addCommentObject = {
                    saveCommentText: ''
                }

                function resetAddCommentState() {
                    scope.addCommentObject.saveCommentText = '';
                }

                scope.addComment = function () {
                    var addCommentObjCopy = Object.assign({}, scope.addCommentObject);
                    var targetUsers = {};

                    var targetUsers = getTargetUsers(addCommentObjCopy.saveCommentText, scope.originalPartners);

                    var comment = {
                        Note: addCommentObjCopy.saveCommentText,
                        CreatedByEntityId: scope.sessionData.EntityId,
                        CreatedByUserName: scope.sessionData.UserName,
                        CreatedByEntity: scope.sessionData.Entity,
                        NoteId: uuid.v4(),
                        Path: scope.path,
                        mode: 'display',
                        TargetUsers: targetUsers,
                        CanResolve: !scope.comments.some(function (outerComments) {
                            return outerComments.CanResolve && !outerComments.IsDeleted 
                        })
                    }

                    try {
                        workflowStateService.saveUnderwritingNote(comment);
                        comment.UpdatedDate = (new Date()).toISOString();
                        scope.comments.push(comment);
                        $rootScope.$broadcast("noteSaved", comment.Path);
                        resetAddCommentState()
                    } catch(error) {
                        notifyService.notify('There was an error saving your comment', true);
                    }
                }

                scope.cancelAddComment = function () {
                    resetAddCommentState();
                    $rootScope.$emit('cancelledAddComment', {
                        path: scope.path
                    });
                }

                // Save comment
                scope.saveCommentObject = {
                    saveCommentText: '',
                    originalComment: null
                }

                function resetSaveCommentState(comment) {
                    comment.mode = 'display';
                    scope.saveCommentObject.saveCommentText  = '';
                    scope.saveCommentObject.originalComment = null;
                }

                scope.saveComment = function (comment) {
                    comment.Note = scope.saveCommentObject.saveCommentText;

                    try {
                        workflowStateService.saveUnderwritingNote(comment);
                        comment.UpdatedDate = (new Date()).toISOString();
                        $rootScope.$broadcast("noteSaved", comment.Path);
                        resetSaveCommentState(comment);
                    } catch(error) {
                        notifyService.notify('There was an error saving your comment', true);
                    }
                }

                scope.cancelSaveComment = function (comment) {
                    if (!comment.UpdatedByUserName) {
                        comment.IsDeleted = true;
                    }
                    else {
                        comment.Note = comment.originalNoteText;
                    }
                    resetSaveCommentState(comment);
                }

                scope.resolveComment = function (comment) {
                    try {
                        comment.IsResolved = true;
                        comment.UpdatedDate = (new Date()).toISOString();
                        workflowStateService.resolveUnderwritingNote(comment);
                        comment.CanResolve = false;
                        $rootScope.$broadcast("noteResolved", comment.Path);
                    } catch(error) {
                        console.log(error);
                        comment.IsResolved = false;
                        comment.CanResolve = true;
                        notifyService.notify('There was an error resolving your comment', true);
                    }
                }

                scope.originalPartners = workflowStateService.getPartnersForPath(scope.path).filter(function (p) {
                    return p.Access.View && !p.IsPrivate;
                });
            }
        };
    }

    commentsMenu.$inject = ['workflowStateService', 'sessionDataService', 'notifyService', '$rootScope'];

    angular.module('ecap.workflow').directive('commentsMenu', commentsMenu);
})();

